import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyHeadMeta, PAGE_SEO } from '../lib/seo';

/**
 * SEO Component that dynamically manages page titles and meta tags
 * Ensures strict compliance with Google SERP limits (max 512px title, max 970px description)
 */
export default function SEO({
  title,
  description,
  image,
  path,
  robots,
  preset,
}) {
  const location = useLocation();

  useEffect(() => {
    const config = preset && PAGE_SEO[preset] ? PAGE_SEO[preset] : {};

    applyHeadMeta({
      title: title || config.title || PAGE_SEO.home.title,
      description: description || config.description || PAGE_SEO.home.description,
      image: image || config.image || PAGE_SEO.home.image,
      path: path || config.path || location.pathname,
      robots: robots || config.robots || 'index, follow',
    });
  }, [title, description, image, path, robots, preset, location.pathname]);

  return null;
}
